import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { FormSection } from 'redux-form'

const Table = ({ classes, columns, extraColumnCell, rows, isRounded }) => {
  return (
    <section
      className={classNames(classes.table, {
        [classes.rounded]: isRounded,
      })}
      data-element="table"
    >
      {/* Table head */}
      <div
        className={classNames(classes.columns, classes.head)}
        data-element="table-headers"
      >
        {columns.map(column => (
          <span className={`${classes.tableCell} ${classes[column.name]}`}>
            <div
              className={classes.headCell}
              key={column.name}
              data-element={`table-header-${column.name}`}
            >
              {column.content}
            </div>
          </span>
        ))}
      </div>
      {extraColumnCell && <div>{extraColumnCell}</div>}
      {/* Table body */}
      {rows.map((row, i) => {
        return (
          <div
            className={classNames(classes.row, {
              [classes.rowStyledStates]: row.withStyledStates,
              [classes.rowActive]: row.active,
              [classes.rowError]: row.isError,
              [classes.rowSuccess]: row.isSuccess,
            })}
            key={row.id}
            data-element={`${i}.table-row`}
            onClick={row.onClick && row.onClick(row.id)}
          >
            <div className={classes.columns}>
              {columns.map(column => {
                return (
                  <span
                    className={`${classes.tableCell} ${classes[column.name]}`}
                  >
                    <FormSection
                      className={classes.cell}
                      key={`${row.id}${column.name}`}
                      name={`${row.id}`}
                    >
                      {row[column.name]}
                    </FormSection>
                  </span>
                )
              })}
            </div>
            {row._extraCell && (
              <div data-element="table-row-extra">{row._extraCell}</div>
            )}
            {row.rowError}
          </div>
        )
      })}
    </section>
  )
}

Table.propTypes = {
  classes: PropTypes.shape({
    table: PropTypes.string,
    columns: PropTypes.string,
    head: PropTypes.string,
    row: PropTypes.string,
    headCell: PropTypes.string,
    cell: PropTypes.string,
    rowActive: PropTypes.string,
    rowError: PropTypes.string,
  }),
  columns: PropTypes.array,
  extraColumnCell: PropTypes.node,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onClick: PropTypes.func,
      withStyledState: PropTypes.bool,
      active: PropTypes.bool,
      isSuccess: PropTypes.bool,
    })
  ),
  isRounded: PropTypes.bool,
}

export default Table
